export default __webpack_public_path__ + "media/images/images_v2/number-983af8b6d646d310836485862af2845d.png";